import { useId, type SelectHTMLAttributes } from 'react'

/** The operating system owns the opened popup, as declared in UX-CONTRACT.md. */
export function NativeSelect({ label, children, className = '', id, ...props }: SelectHTMLAttributes<HTMLSelectElement> & { label: string }) {
  const generatedId = useId()
  return <div className={`ui-select ${className}`}><label htmlFor={id ?? generatedId}>{label}</label><select id={id ?? generatedId} {...props}>{children}</select></div>
}
